import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedAverageRating($partnerId: ID!) {
    community(id: $partnerId) {
      id
      stats {
        averageRating
      }
    }
  }
`);
